import React, { useState } from 'react';
import { TopBar } from '../components/layout/TopBar';
import { Header } from '../components/layout/Header';
import { Navigation } from '../components/layout/Navigation';
import { Footer } from '../components/layout/Footer';
import { ProductGallery } from '../components/product/ProductGallery';
import { ProductInfo } from '../components/product/ProductInfo';
import { ProductDescription } from '../components/product/ProductDescription';
import { RelatedProducts } from '../components/product/RelatedProducts';
import { Phone, ShoppingCart, FileText } from 'lucide-react';
import { usePageTitle } from '../hooks/usePageTitle';
export function ProductDetail() {
  usePageTitle('Versatile 4C Depot 16H - 20 Door Package | MidAtlantic Mailboxes');
  const [options, setOptions] = useState({
    selectedColor: 'Dark Bronze',
    selectedId: 'Standard Decal ID',
    sequence: '',
    reviewRequested: false,
    quantity: 1
  });
  return <div className="min-h-screen flex flex-col bg-white pb-24 lg:pb-0" data-id="element-2052" data-mp="fmcbs8lw3yr1">
      <TopBar data-id="element-2053" data-mp="3jvr0jlvu5o5o" />
      <Header data-id="element-2054" data-mp="3jv95utotnhzv" />
      <Navigation data-id="element-2055" data-mp="3jufzhttryui9" />

      <main className="flex-grow py-8 lg:py-12" data-id="element-2056" data-mp="3on0ngeq02ddv">
        <div className="max-w-7xl mx-auto px-4" data-id="element-2057" data-mp="3ootwg0o359p1">
          {/* Breadcrumbs */}
          <nav className="flex text-sm text-gray-500 mb-8 overflow-x-auto hide-scrollbar whitespace-nowrap pb-2" data-id="element-2058" data-mp="3awx887pjfjxx">
            <ol className="flex items-center space-x-2" data-id="element-2059" data-mp="3fvqjdthcqyux">
              <li data-id="element-2060" data-mp="7ff34815gr17">
                <a href="/Home.html" className="hover:text-brand-green transition-colors" data-id="element-2061" data-mp="7evpv4mg2qti">
                  Home
                </a>
              </li>
              <li data-id="element-2062" data-mp="3tlakyvz75q2n">
                <span data-id="element-2063" data-mp="3tltzs3tjvycg">/</span>
              </li>
              <li data-id="element-2064" data-mp="2fsopv9l54qt">
                <a href="/6m8/commercial-mailboxes-lockers.html" className="hover:text-brand-green transition-colors" data-id="element-2065" data-mp="2f9fd2y03ooe">
                  Commercial Mailboxes &amp; Parcel Lockers
                </a>
              </li>
              <li data-id="element-2066" data-mp="2345k9nlrpdi0">
                <span data-id="element-2067" data-mp="234owqosnf9on">/</span>
              </li>
              <li data-id="element-2068" data-mp="233doabo9ddr7">
                <a href="/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html" className="hover:text-brand-green transition-colors" data-id="element-2069" data-mp="236004ni6mff8">
                  Cluster Mailboxes, CBUs &amp; 4C Mailboxes
                </a>
              </li>
              <li data-id="element-2070" data-mp="1kdfk46nl04su">
                <span data-id="element-2071" data-mp="1kdxo5pghjnbb">/</span>
              </li>
              <li className="text-brand-charcoal font-medium truncate max-w-[200px] sm:max-w-none" data-id="element-2072" data-mp="1kbkw2jh0jwkj">
                Versatile 4C Depot 16H - 20 Door Package
              </li>
            </ol>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 relative" data-id="element-2073" data-mp="1beu52lhbj7wt">
            {/* Left Column: Gallery & Details */}
            <div className="lg:col-span-8" data-id="element-2074" data-mp="35rjyl23ryf3o">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:block" data-id="element-2075" data-mp="35qicm2l80876">
                <div className="lg:hidden mb-8" data-id="element-2076" data-mp="30syugrlejb9y">
                  <ProductGallery selectedColor={options.selectedColor} data-id="element-2077" data-mp="30q2vr11qcikg" />
                </div>

                <div className="hidden lg:block mb-12 max-w-2xl" data-id="element-2078" data-mp="389ly8qqkv4jf">
                  <ProductGallery selectedColor={options.selectedColor} data-id="element-2079" data-mp="3d8yntj8u2ppp" />
                </div>

                <div className="lg:hidden" data-id="element-2080" data-mp="3i1rre3skfs07">
                  <ProductInfo onOptionsChange={setOptions} data-id="element-2081" data-mp="3n0cpnxo9c1m0" />
                </div>
              </div>

              <ProductDescription data-id="element-2082" data-mp="2pcu8bygj5r6e" />
              <RelatedProducts data-id="element-2083" data-mp="2pdm2d4uhbguk" />
            </div>

            {/* Right Column: Info & Sticky Summary (Desktop) */}
            <div className="hidden lg:block lg:col-span-4" data-id="element-2084" data-mp="2uc74j9takaln">
              <ProductInfo onOptionsChange={setOptions} data-id="element-2085" data-mp="2za8m1qb2k1v0" />

              {/* Sticky Summary Panel (Desktop) */}
              <div className="sticky top-32 mt-12 bg-brand-cream rounded-xl border border-brand-border p-6 shadow-sm" data-id="element-2086" data-mp="33derwwu9rr0y">
                <h3 className="font-serif font-bold text-xl text-brand-charcoal mb-4 border-b border-brand-border pb-4" data-id="element-2087" data-mp="ejzrm386u3rg">
                  Order Summary
                </h3>

                <div className="space-y-3 text-sm mb-6" data-id="element-2088" data-mp="h45yojs3mac8">
                  <div className="flex justify-between" data-id="element-2089" data-mp="h6scv29hvo3f">
                    <span className="text-gray-600" data-id="element-2090" data-mp="c75z8rpr85u3">Color:</span>
                    <span className="font-medium text-brand-charcoal" data-id="element-2091" data-mp="r3oeco0z79yh">
                      {options.selectedColor}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-2092" data-mp="m6es1h8vveev">
                    <span className="text-gray-600" data-id="element-2093" data-mp="102s05zrj23go">Door ID:</span>
                    <span className="font-medium text-brand-charcoal" data-id="element-2094" data-mp="v503ytjunv6o">
                      {options.selectedId}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-2095" data-mp="19vpju9899ygv">
                    <span className="text-gray-600" data-id="element-2096" data-mp="14vl2kgziwzpl">Quantity:</span>
                    <span className="font-medium text-brand-charcoal" data-id="element-2097" data-mp="1iu1k72yxcami">
                      {options.quantity}
                    </span>
                  </div>
                  {options.sequence && <div className="flex justify-between" data-id="element-2098" data-mp="1xh9qpqhafrs5">
                      <span className="text-gray-600" data-id="element-2099" data-mp="1xht4qw3thw0w">Sequence:</span>
                      <span className="font-medium text-brand-charcoal truncate max-w-[150px]" data-id="element-2100" data-mp="22f1oh14m6849">
                        {options.sequence}
                      </span>
                    </div>}
                  <div className="flex justify-between pt-3 border-t border-brand-border/50" data-id="element-2101" data-mp="1tdv76pu54t9y">
                    <span className="text-gray-600" data-id="element-2102" data-mp="1epqohlv38hr6">Review Requested:</span>
                    <span className={`font-bold ${options.reviewRequested ? 'text-brand-green' : 'text-gray-400'}`} data-id="element-2103" data-mp="1jhidvt2ichfq">
                      {options.reviewRequested ? 'Yes' : 'No'}
                    </span>
                  </div>
                </div>

                <div className="text-3xl font-bold text-brand-green mb-6 text-center" data-id="element-2104" data-mp="vrec7r8vqrrd">
                  $4,353.00
                </div>

                <div className="space-y-3" data-id="element-2105" data-mp="10q7nre4lw8ow">
                  {options.reviewRequested ? <a href="/ContactUs.html" className="w-full bg-brand-green hover:bg-brand-green/90 text-white py-3.5 rounded-md font-bold transition-colors flex items-center justify-center gap-2 shadow-sm" data-id="element-2106" data-mp="32hhmumkxm9pf">
                      <FileText size={18} data-id="element-2107" data-mp="2opl0kz5y2u0y" /> Request Review
                    </a> /* TODO: wire to Website Forge product add-to-cart form */ : <button type="button" aria-label="Add to cart (Website Forge integration pending)" data-wf-add-to-cart-todo="true" className="w-full bg-brand-red hover:bg-brand-red/90 text-white py-3.5 rounded-md font-bold transition-colors flex items-center justify-center gap-2 shadow-sm" data-id="element-2108" data-mp="3hd7bkshi50xu">
                      <ShoppingCart size={18} data-id="element-2109" data-mp="1w048y3q5fh5s" /> Add to Cart
                    </button>}
                  <a href="tel:301-620-7585" className="w-full bg-white border border-brand-border hover:border-brand-green text-brand-charcoal py-3 rounded-md font-bold transition-colors flex items-center justify-center gap-2" data-id="element-2110" data-mp="1lwfskw9e0hxj">
                    <Phone size={18} data-id="element-2111" data-mp="20kk2pbudjl4p" /> Call 301-620-7585
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2112" data-mp="24orszdghd951" />

      {/* Mobile Sticky Bottom Bar (Product Specific) */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-brand-border shadow-[0_-10px_20px_rgba(9,46,37,0.05)] z-50 p-4 pb-safe flex items-center gap-3" data-id="element-2113" data-mp="29jxdq8y5chrj">
        <div className="flex-1" data-id="element-2114" data-mp="2jid60f8wtx2m">
          <div className="text-xs text-gray-500 font-medium" data-id="element-2115" data-mp="2jhli7qlk13mw">Total</div>
          <div className="text-lg font-bold text-brand-green leading-none" data-id="element-2116" data-mp="k84z9w1elohy">
            $4,353.00
          </div>
        </div>
        <a href="#configure-options" className="bg-brand-charcoal text-white px-6 py-2.5 rounded-md font-bold text-sm" data-id="element-2117" data-mp="p7rfmecj3kuz">
          Configure
        </a>
        {/* TODO: wire to Website Forge product add-to-cart form */}
        <a href="/ContactUs.html" className="bg-brand-green text-white px-4 py-2.5 rounded-md font-bold text-sm flex items-center justify-center" data-id="element-2118" data-mp="30ta3q0ioewox">
          Help
        </a>
      </div>
    </div>;
}